<template>
    <TitlePage/>
    <PdfPanel :information-Indicators="pdfList" />
  </template>

  <script>
  import PdfPanel from '../../../components/IndicatorInformationPdfPanel/IndicatorsInformationPdfPanel.vue'
  import TitlePage from '../../../components/ViewsTitle/ViewsTitle.vue'
  import pdfs from './ClimatologicalPdfs.js'

  export default {
    name: 'ClimatologicalInformationPdf',

    data () {
      return {
        pdfList: pdfs
      }
    },

    components: {
      PdfPanel,
      TitlePage
    }
  }
</script>